exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".load-back[data-v-f2fe9b0e]{background-color:#f2f2f2}.slide-enter-active[data-v-f2fe9b0e],.slide-leave-active[data-v-f2fe9b0e]{-webkit-transition:all .2s;transition:all .2s;position:absolute;left:80px}.slide-enter[data-v-f2fe9b0e]{opacity:1;-webkit-transform:translateX(100%);transform:translateX(100%)}.slide-leave-to[data-v-f2fe9b0e]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2fe9b0e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/DashBoardBody.vue
// module id = 93Y8
// module chunks = 0